import { Col, FlexboxGrid } from 'rsuite';
import UserIcon from '../../assets/icons/roles/user.svg';
import VendorIcon from '../../assets/icons/roles/vendor.svg';
import ConsultantIcon from '../../assets/icons/roles/consultant.svg';
import CorporateIcon from '../../assets/icons/roles/corporate.svg';
import { useNavigate } from 'react-router-dom';
import { handleGetConsultantRegisterRequest } from '../../api-handler';
import { useState, useEffect } from 'react';
import { CustomLoader } from '../../components/basic/loader';
import { STATUS_CONVERTOR } from '../../utils/helpers';

export const ChooseRole = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [consultantRegisterRequest, setConsultantRegisterRequest] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await handleGetConsultantRegisterRequest();
      if (res.ok) {
        setConsultantRegisterRequest(res.data.Status);
      }
      setLoading(false);
    })();
  }, []);

  return (
    <>
      <h4 className="text-h4">لطفا نقش درخواستی مورد نظر خود را انتخاب کنید</h4>
      {loading ? (
        <CustomLoader />
      ) : (
        <FlexboxGrid className="mt-12">
          <FlexboxGrid.Item
            as={Col}
            colspan={24}
            md={12}
            lg={12}
            xl={6}
            className="max-w-[100%] mb-2">
            <div className="bg-[--rs-primary-50] flex flex-col items-center rounded-lg pt-5 pb-6 border-[1px] border-[--rs-primary-500] opacity-25">
              <h3 className="text-h3 mb-4 text-[--rs-primary-800]">کارجو</h3>
              <img src={UserIcon} alt="کارجو" />
              <span className="font-bold">
                <br />{' '}
              </span>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item
            as={Col}
            colspan={24}
            md={12}
            lg={12}
            xl={6}
            className="max-w-[100%] mb-2">
            <div className="bg-[--rs-primary-50] flex flex-col items-center rounded-lg pt-5 pb-6 border-[1px] border-[--rs-primary-500] opacity-25">
              <h3 className="text-h3 mb-4 text-[--rs-primary-800]">کارفرما</h3>
              <img src={VendorIcon} alt="کارفرما" />
              <span className="font-bold">
                <br />{' '}
              </span>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item
            as={Col}
            colspan={24}
            md={12}
            lg={12}
            xl={6}
            className="max-w-[100%] mb-2">
            <div
              className={`${
                consultantRegisterRequest === 'Pending' || consultantRegisterRequest === 'Accepted'
                  ? 'opacity-50'
                  : null
              } bg-[--rs-primary-50] hover:bg-[--rs-primary-100] flex flex-col items-center rounded-lg pt-5 pb-6 border-[1px] border-[--rs-primary-500] cursor-pointer`}
              onClick={() => {
                if (
                  consultantRegisterRequest === 'Pending' ||
                  consultantRegisterRequest === 'Accepted'
                ) {
                  navigate('/choose-role');
                } else {
                  navigate('/consultant/personal');
                }
              }}>
              <h3 className="text-h3 mb-4 text-[--rs-primary-800]">مشاور</h3>
              <img src={ConsultantIcon} alt="مشاور" />
              <span className="font-bold">
                {STATUS_CONVERTOR[consultantRegisterRequest] ?? <br />}
              </span>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item
            as={Col}
            colspan={24}
            md={12}
            lg={12}
            xl={6}
            className="max-w-[100%] mb-2">
            <div className="bg-[--rs-primary-50] flex flex-col items-center rounded-lg pt-5 pb-6 border-[1px] border-[--rs-primary-500] opacity-25">
              <h3 className="text-h3 mb-4 text-[--rs-primary-800]">سرمایه گذار</h3>
              <img src={CorporateIcon} alt="سرمایه گذار" />
              <span className="font-bold">
                <br />{' '}
              </span>
            </div>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      )}
    </>
  );
};
